import { render, staticRenderFns } from "./SetupSubscription.vue?vue&type=template&id=3c17b070&scoped=true&"
import script from "./SetupSubscription.vue?vue&type=script&lang=js&"
export * from "./SetupSubscription.vue?vue&type=script&lang=js&"
import style0 from "./SetupSubscription.vue?vue&type=style&index=0&id=3c17b070&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c17b070",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3c17b070')) {
      api.createRecord('3c17b070', component.options)
    } else {
      api.reload('3c17b070', component.options)
    }
    module.hot.accept("./SetupSubscription.vue?vue&type=template&id=3c17b070&scoped=true&", function () {
      api.rerender('3c17b070', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/SetupSubscription.vue"
export default component.exports